import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconQuestionmarkCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconQuestionmarkCircle"><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><Path d="M12 13.25C12 11.0682 14.2499 11.3344 14.25 9.3158C14.2501 6.64348 10.2339 6.6432 9.75 8.85662" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Circle cx="12" cy="16.5" r="1" fill="currentColor"/></CentralIconBase>;
});

export default IconQuestionmarkCircle;
